import { useSessionCheckInStore } from '@/zustand/session-check-in-store';

export function resetSessionCheckIn() {
  useSessionCheckInStore.getState().resetStore();
}
